import color from 'color';
export var toRgbAsHex = function (value) {
    if (value) {
        try {
            return color(sanitizeDoubleHash(value)).rgb().hex();
        }
        catch (error) { }
    }
    return '';
};
function sanitizeDoubleHash(value) {
    return value.replace('##', '#');
}
//# sourceMappingURL=to-rgb-as-hex.js.map